export function normalizeTrend(trend) {
    if (trend === "down" || trend === "decreased") return "down";
    if (trend === "up" || trend === "increased") return "up";
    return "normal";
}

export function hasDirectionalTrend(trend) {
    const n = normalizeTrend(trend);
    return n === "up" || n === "down";
}

export function isValidOddValue(value) {
    return value !== null && value !== undefined && value !== "" && value !== "-";
}

